<template v-slot:activator="{ on }">
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="fechaDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Itens do Recibo</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <div id="downloadpdf">
        <div
          id="invoice"
          ref="content"
        >
          <!-- CARD EMPRESA -->
          <card-empresa
            id="tabela"
            class="ma-2 ml-2 mr-2"
            :empresa="empresarecibo"
          />
          <v-container v-if="exibeBtnDownload">
            <v-btn
              :id="$style.btnDownload"
              v-model="recibopdf"
              class="button__full"
              elevation="2"
              fab
              small
              color="primary"
              floating
              @click="generatePDF()"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-container>
          <!-- TABELA -->
          <v-simple-table>
            <thead>
              <tr style="text-weight=bold">
                <th class="primary--text">
                  Descrição
                </th>
                <th class="primary--text text-right">
                  Qtde
                </th>
                <th class="primary--text text-right">
                  Valor
                </th>
                <th class="primary--text text-right">
                  Valor Critério
                </th>
                <th class="primary--text text-right">
                  Débito
                </th>
                <th class="primary--text text-right">
                  Crédito
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in itensrecibo"
                :key="index"
              >
                <td>
                  {{ item.descricao }}
                </td>
                <td
                  class="text-right"
                >
                  {{ item.quantidade }}
                </td>
                <td
                  class="text-right"
                >
                  {{ parseMoeda(item.valor,4) }}
                </td>
                <td
                  class="text-right"
                >
                  {{ item.valorcriterio }}
                </td>
                <td
                  class="text-right"
                >
                  {{ parseMoeda(item.debito,2) }}
                </td>
                <td
                  class="text-right"
                >
                  {{ parseMoeda(item.credito,2) }}
                </td>
              </tr>
            </tbody>
            <tfoot
              class="totalizador"
            >
              <td />
              <td />
              <td />
              <td />
              <td
                class="text-right"
              >
                {{ computedSomaDebito }}
              </td>
              <td
                class="text-right"
              >
                {{ computedSomaCredito }}
              </td>
            </tfoot>
          </v-simple-table>
        </div>
        <!-- card 1 e 2 -->
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              class="mx-auto ml-2 mr-2 mb-0"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Total Leite Bom: </b>{{ parseMoeda(recibo.leitebom,4) }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Total Geral Leite: </b>{{ parseMoeda(recibo.leitebom + recibo.leiteacido,4) }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Preço Médio: </b>R$ {{ parseMoeda(recibo.precomedio,4) }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Liquido a Receber: </b>R$ {{ parseMoeda(recibo.total,4) }}
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-card
              class="mx-auto ml-2 mr-2 mb-0"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Banco: </b>{{ recibo.banco }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Agência: </b>{{ recibo.agencia }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Conta: </b>{{ recibo.conta }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Titular: </b>{{ recibo.titular }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>CPF Titular: </b>{{ recibo.cpftitular }}
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <v-card
              class="mx-auto ml-2 mt-0 mr-2"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Data de pagamento: </b>{{ formatDiaMesAno(recibo.datapagamento) }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Data inicio: </b>{{ formatDiaMesAno(recibo.datainicio) }}
                </v-list-item-content>
                <v-list-item-content class="text--secondary">
                  <b>Data fim: </b>{{ formatDiaMesAno(recibo.datafim) }}
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <!-- CARD MEDIA GEOMETRICA -->
        <v-row v-if="recibo.mediaGeometrica !== null && recibo.mediaGeometrica !== ''">
          <v-col
            cols="30"
          >
            <v-card
              class="mx-auto ml-2 mt-0 mr-2"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content
                  class="text--secondary"
                >
                  <b>Média Geometrica: </b>
                  <div
                    id="mediaGeometrica"
                    :class="$style.CSSTableGenerator"
                    v-html="recibo.mediaGeometrica"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <!-- CARD ANALISE -->
        <v-row v-if="recibo.analise !== null && recibo.analise !== ''">
          <v-col
            cols="30"
          >
            <v-card
              class="mx-auto ml-2 mt-0 mr-2"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Analises: </b>
                  <div
                    :class="$style.CSSTableGenerator"
                    v-html="recibo.analise"
                  />
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <!-- CARD OBSERVACAO -->
        <v-row>
          <v-col
            cols="12"
          >
            <v-card
              class="mx-auto ml-2 mt-0 mr-2"
              outlined
              elevation="1"
            >
              <v-list-item>
                <v-list-item-content class="text--secondary">
                  <b>Observação: </b>{{ recibo.observacao }}
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import CardEmpresa from '../component/CardEmpresa'
  import utils from '../../../services/utils'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardFormsItensReciboForm',
    components: {
      CardEmpresa,
    },
    mixins: [CardEmpresa, utils],
    props: {
      recibo: {
        type: Object,
        default: function () {
          return {
            banco: '',
            agencia: '',
            conta: '',
            titular: '',
            total: '',
            cpftitular: '',
            leitebom: 0,
            precomedio: 0,
          }
        },
      },
      itensrecibo: {
        type: Array,
        default: function () {
          return [{
            descricao: '',
            quantidade: 0,
            valor: 0,
            valorcriterio: 0,
            debito: 0,
            credito: 0,
          }]
        },
      },
      exibedialog: {
        type: Boolean,
        default: false,
      },
      empresarecibo: {
        type: Object,
        default: function () {
          return {}
        },
      },
    },
    data: () => ({
      somacredito: 0,
      somadebito: 0,
      exibedialogInterno: false,
      reciboItem: [],
      descricao: '',
      quantidade: 0,
      valor: 0,
      valorcriterio: 0,
      debito: 0,
      credito: 0,
      recibopdf: '',
    }),

    computed: {
      computedSomaDebito () {
        return this.parseMoeda(this.itensrecibo.reduce((soma, item) => soma + item.debito, 0), 2)
      },
      computedSomaCredito () {
        return this.parseMoeda(this.itensrecibo.reduce((soma, item) => soma + item.credito, 0), 2)
      },
    },

    watch: {
      exibedialog: function (val) {
        this.exibedialogInterno = val
      },
    },
    methods: {
      fechaDialog () {
        this.exibedialogInterno = false
        this.$emit('update-dialog', this.exibedialogInterno)
      },
      exibeBtnDownload () {
        return !navigator.userAgent.match(/iPhone/i)
      },
      async generatePDF () {
        const doc = new JSPDF({
          orientation: 'portrait',
          unit: 'px',
          format: 'a4',
          compress: true,
        })
        doc.setHeaderFunction('Content-Type', 'application/pdf')

        // cabeçalho
        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
          },
          head: [['Empresa', 'Razão Social', 'CNPJ']],
          body: [[this.empresarecibo.nome, this.empresarecibo.razaosocial, this.empresarecibo.cnpj]],
        })

        // corpo do recibo
        const columns = [
          { title: 'Descrição', dataKey: 'descricao' },
          { title: 'Qtde', dataKey: 'quantidade' },
          { title: 'Valor', dataKey: 'valor' },
          { title: 'Valor Criterio', dataKey: 'valorcriterio' },
          { title: 'Débito', dataKey: 'debito' },
          { title: 'Crédito', dataKey: 'credito' },
        ]

        doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)
        doc.autoTable({
          margin: { left: 10, right: 10 },
          columns,
          body: this.itensrecibo,
        })

        // resumo
        doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
            halign: 'right',
            fontSize: 9,
          },
          head: [['Total Débito', 'Total Crédito']],
          body: [[this.computedSomaDebito, this.computedSomaCredito]],
        })

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
          },
          head: [['Total Leite Bom', 'Total Geral Leite', 'Preço Médio', 'Líquido a Receber']],
          body: [
            [
              this.parseMoeda(this.recibo.leitebom, 4),
              this.parseMoeda(this.recibo.leitebom + this.recibo.leiteacido, 4),
              this.parseMoeda(this.recibo.precomedio, 4),
              this.parseMoeda(this.recibo.total, 4),
            ],
          ],
        })

        doc.setLineWidth(0.01).line(0.5, 1.1, 8.0, 1.1)

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
          },
          head: [['Banco', 'Agência', 'Conta', 'Titular', 'CPF Titular']],
          body: [[this.recibo.banco, this.recibo.agencia, this.recibo.conta, this.recibo.titular, this.recibo.cpftitular]],
        })

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0],
            textColor: [0, 0, 0],
          },
          head: [['Data pagamento', 'Data início', 'Data fim']],
          body: [[this.formatDiaMesAno(this.recibo.datapagamento, 'dd-MM-yyyy'), this.formatDiaMesAno(this.recibo.datainicio, 'dd-MM-yyyy'), this.formatDiaMesAno(this.recibo.datafim, 'dd-MM-yyyy')]],
        })

        if (this.recibo.mediaGeometrica !== undefined && this.recibo.mediaGeometrica !== null && this.recibo.mediaGeometrica !== '') {
          var tbMediaGeometrica = this.generateTable(this.recibo.mediaGeometrica)

          doc.autoTable({
            margin: { left: 10, right: 10 },
            body: [['']],
          })
          doc.setFontSize(12)
          doc.text('Média Geométrica: ', 14, doc.autoTable.previous.finalY + 10)

          doc.autoTable({
            head: tbMediaGeometrica.slice(0, 1),
            body: tbMediaGeometrica.slice(1),
            startY: doc.autoTable.previous.finalY + 15,
            margin: { left: 10, right: 10 },
            tableWidth: 'auto',
            theme: 'grid',
            headStyles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            styles: {
              fontSize: 11,
              cellPadding: 1,
              fillColor: [0, 0, 0, 0],
              textColor: [0, 0, 0],
            },
          })
        }

        if (this.recibo.analise !== undefined && this.recibo.analise !== null && this.recibo.analise !== '') {
          var tbAnalise = this.generateTable(this.recibo.analise)

          doc.autoTable({
            margin: { left: 10, right: 10 },
            body: [['']],
          })

          doc.setFontSize(12)
          doc.text('Análises: ', 14, doc.autoTable.previous.finalY + 10)

          doc.autoTable({
            head: tbAnalise.slice(0, 1),
            body: tbAnalise.slice(1),
            startY: doc.autoTable.previous.finalY + 15,
            margin: { left: 10, right: 10 },
            tableWidth: 'auto',
            theme: 'grid',
            headStyles: {
              fillColor: [0, 0, 0, 0.1],
              textColor: [0, 0, 0],
            },
            styles: {
              fontSize: 11,
              cellPadding: 1,
              fillColor: [0, 0, 0, 0],
              textColor: [0, 0, 0],
            },
          })
        }

        doc.autoTable({
          margin: { left: 10, right: 10 },
          styles: {
            fillColor: [0, 0, 0, 0.1],
            textColor: [0, 0, 0],
          },
          head: [['Observações']],
          body: [[this.recibo.observacao]],
        })

        // footer
        doc.setFont('times').setFontSize(11).setTextColor(0, 0, 255).text('Desenvolvido por: Magistech Sistemas - www.magistech.com.br', 5, doc.internal.pageSize.height - 0.9)

        const fileName = 'Recibo_' + this.formatedDate(this.recibo.datapagamento, 'YYYY-MM-DD') + '_' + Math.floor(Math.random() * 100) + '.pdf'
        this.recibopdf = doc.output('dataurlstring', fileName)
        const downloadLink = document.createElement('a')
        downloadLink.href = this.recibopdf
        downloadLink.download = fileName
        const acao = 'gerarPDF'
        const dados = [
          { funcao: acao },
          { link: downloadLink.href },
          { nomearquivo: fileName },
        ]
        downloadLink.click()
        const isWebView = localStorage.getItem('platform')
        if (isWebView === 'android' || isWebView === 'ios') {
          window.ReactNativeWebView.postMessage(JSON.stringify(dados))
        }
      },
      generateTable (html) {
        var tempElement = document.createElement('div')
        tempElement.innerHTML = html

        var tableData = []
        var rows = tempElement.getElementsByTagName('tr')
        for (var i = 0; i < rows.length; i++) {
          var rowData = []
          var cols = rows[i].getElementsByTagName('th')
          for (var j = 0; j < cols.length; j++) {
            rowData.push(cols[j].innerText.trim())
          }
          var linha = rows[i].getElementsByTagName('td')
          for (var y = 0; y < linha.length; y++) {
            rowData.push(linha[y].innerText.trim())
          }
          tableData.push(rowData)
        }
        return tableData
      },
    },
  }
</script>

<style module>
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }
  .totalizador { background-color: rgba(78, 119, 173, 0.2);}
  .totalizador td { font-weight: 500;}
  #btnDownload {
  position: fixed;
  top: 100px;
  right: 20px;
  z-index: 999;
}
.CSSTableGenerator {
    margin: 0px;
    padding: 0px;
    width: 100%;
    border: 1px solid #D3D3D3;
    -moz-border-radius-bottomleft: 0px;
    -webkit-border-bottom-left-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-border-radius-bottomright: 0px;
    -webkit-border-bottom-right-radius: 0px;
    border-bottom-right-radius: 0px;
    -moz-border-radius-topright: 0px;
    -webkit-border-top-right-radius: 0px;
    border-top-right-radius: 0px;
    -moz-border-radius-topleft: 0px;
    -webkit-border-top-left-radius: 0px;
    border-top-left-radius: 0px;
  }
  .CSSTableGenerator table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    border: #D3D3D3;
  }
  /* linhas da tabela */
  .CSSTableGenerator td {
    vertical-align: middle;
    border: 0px solid #D3D3D3;
    border-width: 0px 0.1px 0.1px 0px;
    text-align: left;
    padding: 5px;
    font-size: 10px;
    font-family: Arial;
    font-weight: normal;
    color: #000000;
  }
  .CSSTableGenerator thead {
    background-color: #C0C0C0;
  }
   /* cabeçalho da tabela */
  .CSSTableGenerator tr:first-child th {
    border: 1px solid #D3D3D3;
    text-align: center;
    border-width: 0px 0.1px 0.1px 0px;
    font-size: 14px;
    font-family: Arial;
    font-weight: bold;
    color: #000000;
  }
.formatarPdf {
  position: absolute;
  background: #0c0b0a;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0.1px solid #000000;
}
</style>
